
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-collections");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/collections/index.js
// module id = null
// module chunks = 